import {flatten, sortBy} from 'lodash'
import {createSelector} from 'reselect'

import {ISelectReviewer, IState, IReviewer} from './model'

export const selectReviewers = createSelector<{reviewers: IState}, IReviewer[], ISelectReviewer[]>(
  ({reviewers}: {reviewers: IState}) => reviewers.items,
  (items) => items.map((item) => ({
    ...item
  })),
)

export const selectReviewer = ({reviewers}: {reviewers: IState}, npi: string): ISelectReviewer | null => {
  const reviewer = reviewers.items.find((s) => s.npi === npi)
  if (!reviewer) return null
  return {
    ...reviewer,
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/reviewers/selectors.ts